import { MantineTheme } from '@mantine/core';
import { SecurityFeatureType } from '@dealstack/shared/lib/generated';

export const getSecurityFeatureTypeColors = (
	theme: MantineTheme,
	securityFeatureType: SecurityFeatureType
) => {
	switch (securityFeatureType) {
		case SecurityFeatureType.RESIDUE:
			return {
				borderColor: theme.colors.orange[6],
				color: theme.colors.orange[8],
			};
		case SecurityFeatureType.INTEREST:
		case SecurityFeatureType.PRINCIPAL:
			return {
				borderColor: theme.colors.cyan[8],
				color: theme.colors.cyan[9],
			};
		case SecurityFeatureType.TRACKING:
			return {
				borderColor: theme.colors.lime[8],
				color: theme.colors.lime[9],
			};
		case SecurityFeatureType.CATCH_UP:
			return {
				borderColor: theme.colors.blue[8],
				color: theme.colors.blue[9],
			};
		case SecurityFeatureType.OPTION:
			return {
				borderColor: theme.colors.red[8],
				color: theme.colors.red[9],
			};
		case SecurityFeatureType.LIQUIDATION_PREFERENCE:
			return {
				borderColor: theme.colors.grape[6],
				color: theme.colors.grape[8],
			};
		default:
			return {
				borderColor: theme.colors.gray[4],
				color: theme.colors.gray[8],
			};
	}
};
